export enum EPrivacyType {
  TERMS = "terms",
  PRIVACY_POLICY = "privacy-policy",
}
